export const PROFILE_ENDPOINTS = {
  CURRENT_USER: '/api/users/current-user/',
  UPLOAD_PHOTO: '/api/users/current-user/upload-photo/',
} as const;


